import React from "react";

const Header = () => {
  return (
    <div className="header">
      <p className="header-heading">Admin UI</p>
    </div>
  );
};

export default Header;
